import { Theme } from "@emotion/react";
import styled from "@emotion/styled";

type StackProps = {
  gap?: keyof Theme["spacing"]["stack"];
  relative?: boolean;
};
const Stack = styled.div<StackProps>(
  ({ gap = "lg", relative = false, theme }) => ({
    "div &>*": {
      marginTop: 0,
      marginBottom: 0,
    },
    "div &>*+*": {
      marginTop:
        gap === "0"
          ? "0"
          : `${theme.spacing.stack[gap]}${relative ? "em" : "rem"}`,
    },
  })
);

export { Stack };
